import { Controller } from "@hotwired/stimulus";

/**
 * The project search controller.
 *
 * This controller assumes the following markup: a turbo-frame with tabs, page
 * numbers, and projects; and, a GET form with the frame as its target.
 *
 * Typing in the form submits it, using the controller's update method below,
 * and refreshes the frame's contents.
 *
 * Projects are controlled by three params: the search term (outside the frame),
 * the current tab (inside), and the page number (inside).
 *
 * The search term and current tab move together. Changes to one need to have
 * the current value of the other. Tabs have the search term in their path with
 * Rails path helpers, and the form picks up the current type from a hidden
 * field rendered inside the frame.
 *
 * In addition, the frame's query string parameters are "lifted" to the page's
 * query string parameters thanks to the data-turbo-action="advance" attribute.
 */
export default class extends Controller {
  // The debounce below can still be pending when the user acts on the search
  // themselves. Pressing Enter submits this GET form natively and immediately,
  // so the timer would fire a second, duplicate request. Clicking a result
  // starts a page visit, and a search landing mid-visit renders the frame and
  // puts the index back, cancelling the navigation.
  //
  // Tab clicks are frame navigations, not visits, so they leave the debounce
  // alone -- the pending search should run, and it picks up the new tab.
  cancelSearch() {
    clearTimeout(this.timeout);
  }

  update() {
    clearTimeout(this.timeout);

    this.timeout = setTimeout(() => {
      this.element.requestSubmit();
    }, 300);
  }
}
